import { render } from "./Robot.vue?vue&type=template&id=2b2d1d5a&scoped=true"
import script from "./Robot.vue?vue&type=script&lang=js"
export * from "./Robot.vue?vue&type=script&lang=js"

import "./Robot.vue?vue&type=style&index=0&id=2b2d1d5a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2b2d1d5a"

export default script